// ActivityTabs.jsx — m3-11 the Activity segmented control (Project Board ⇄ Triggered Tasks).
//
// The sticky, centered, blurred segmented control from design docs/04 (.act-* / .act-seg).
// HOST-CONTROLLED: the active tab + the change handler come from the shell (m3-06a holds
// `activityView`, lifted so it survives mode switches and the agent panel mirrors the page).
// In the agent panel the strip is plain (no sticky/blur); on the full page it's sticky+blur.
//
// Extends m3-10's minimal /activity mount — it does NOT replace the route/controller, it
// supplies the real tab UI the shell renders inside the mount.

import React from "react"
import { buildTabStrip, selectTab } from "./activityTabsViewModel.js"

// tiny inline icons (stroke-2 / round-cap, matching the nav set)
function TabIcon({ name }) {
  if (name === "activity") {
    return (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
      </svg>
    )
  }
  // robot
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="4" y="8" width="16" height="11" rx="2" />
      <path d="M12 8V5M9 3h6" />
      <circle cx="9" cy="13" r="1" /><circle cx="15" cy="13" r="1" />
    </svg>
  )
}

export default function ActivityTabs({ active, placement = "page", onChange }) {
  const strip = buildTabStrip(active, placement)

  const handle = (id) => {
    const next = selectTab(strip.active, id)
    if (next !== strip.active && typeof onChange === "function") onChange(next)
  }

  return (
    <div className={`act-tabs ${strip.sticky ? "act-tabs--sticky" : "act-tabs--plain"}`}>
      <div className="act-seg" role="tablist" aria-label="Activity">
        {strip.tabs.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={t.selected}
            className={`act-seg__btn ${t.selected ? "is-active" : ""}`}
            onClick={() => handle(t.id)}
          >
            <span className="act-seg__ico"><TabIcon name={t.icon} /></span>
            <span className="act-seg__label">{t.label}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
